'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userWalletTransactions = require('./user-wallet-transactions.html');

var _userWalletTransactions2 = _interopRequireDefault(_userWalletTransactions);

var _userWalletTransactions3 = require('./user-wallet-transactions.controller');

var _userWalletTransactions4 = _interopRequireDefault(_userWalletTransactions3);

require('./user-wallet-transactions.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userWalletTransactionsComponent = {
  restrict: 'E',
  bindings: {
    walletTransactions: '<'
  },
  template: _userWalletTransactions2.default,
  controller: _userWalletTransactions4.default,
  controllerAs: 'vm'
};

exports.default = userWalletTransactionsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-wallet-transactions/user-wallet-transactions.component.js
 **/